import styled, { css } from 'styled-components'
import Colors from '../../constants/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  .timeItems {
    display: flex;
    flex-direction: column;
    @media (max-width: 650px) {
      flex-direction: row;
      margin-left: -25px;
      width: 100vw;
      overflow: auto;
      align-items: center;
      height: 80px;
      ::-webkit-scrollbar { width: 0; height: 0; }
      -ms-overflow-style: none;
      scrollbar-width: none;
    }
  }
`

export const ItemLink = styled.span`
  transition-duration: 0.2s;
  color: #000;
  cursor: pointer;
  font-family: StolzlLight;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 2px;
  margin-bottom: 15px;
  &:hover {
    color: ${Colors.primaryHover};
  }
  ${props => props.selected
    && css`
      font-family: StolzlMedium;
      font-size: 22px;
      color: ${Colors.primary};
    `}
`

export const TimeItemLink = styled(ItemLink)`
  @media (max-width: 650px) {
    &:hover {
      color: ${Colors.primary};
    }
    font-size: 14px;
    margin-right: 15px;
    letter-spacing: 0px;
    line-height: 22px;
    margin-bottom: 0px;
    &:first-child {
      padding-left: 20px;
    }
    &:last-child {
      padding-right: 20px;
    }
    ${props => props.selected
      && css`
        .label {
          display: flex;
          justify-content: center;
          align-items: center;
          min-width: 55px;
          min-height: 55px;
          width: 55px;
          height: 55px;
          border-radius: 28px;
          box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        }
      `}
  }
`
